import styled from 'styled-components';

export const Content = styled.div`
	width: 734px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	padding: 40px;
`;

export const Title = styled.div`
	font-weight: bold;
	font-size: 24px;
	line-height: 34px;
	text-align: center;
`;

export const Text = styled.div`
	max-width: 605px;
	margin: 32px auto;
	font-size: 18px;
	line-height: 24px;
`;

export const Button = styled.a`
	background: #829cfc;
	border-radius: 8px;
	font-weight: bold;
	font-size: 16px;
	line-height: 22px;
	padding: 13px 20px;
	display: inline-block;
	letter-spacing: 0.04em;
	text-transform: uppercase;
	color: #ffffff;
	&:visited,
	&:focus,
	&:active,
	&:hover {
		color: white;
	}
	margin: 0 auto;
`;
